import React, { FC } from 'react';

import { SecondaryColorsProps } from '../../../styles/theme/color';
import { StyledIndicator, Label, Signifier } from './styles';

export const Indicator: FC<IndicatorProps> = ({
  label,
  color = 'blueLight',
  className,
  reversedDirection = false,
}) => {
  return (
    <StyledIndicator
      $reversedDirection={reversedDirection}
      className={className}
    >
      <Signifier color={color} />
      <Label>{label}</Label>
    </StyledIndicator>
  );
};

export interface IndicatorProps {
  label: string;
  color?: SecondaryColorsProps;
  className?: string;
  reversedDirection?: boolean;
}
